(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header.classList.contains('menu-open')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projecten-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vbm-project-gallery')) {
    customElements.define('vbm-project-gallery', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.viewport || !this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.dialog = this.querySelector('dialog');
        this.index = 0;

        if (this.slides.length > 1) {
          this.querySelector('[data-controls]').hidden = false;
          this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
          this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
          this.viewport.addEventListener('scroll', () => {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.update());
          }, { ...options, passive: true });
          this.viewport.addEventListener('keydown', (event) => {
            if (event.target !== this.viewport) return;
            const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
            if (!(event.key in destinations)) return;
            event.preventDefault();
            this.goTo(destinations[event.key]);
          }, options);
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: 'instant' });
            });
            this.resizeObserver.observe(this.viewport);
          }
          this.update();
        }

        if (this.dialog && typeof this.dialog.showModal === 'function') {
          this.querySelectorAll('[data-enlarge]').forEach((link) => {
            link.addEventListener('click', (event) => {
              if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
              event.preventDefault();
              const original = link.querySelector('img');
              const enlarged = this.dialog.querySelector('img');
              enlarged.src = link.href;
              enlarged.alt = original.alt;
              this.dialog.querySelector('[data-caption]').textContent = link.dataset.caption;
              this.opener = link;
              this.dialog.showModal();
            }, options);
          });
          this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => {
            if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          }, options);
        }
      }

      goTo(index) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({ left: destination * this.viewport.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
      }

      update() {
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / (this.viewport.clientWidth || 1))));
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        const message = `Foto ${this.index + 1} van ${this.slides.length} · ${this.slides[this.index].dataset.phase}`;
        if (this.status.textContent !== message) this.status.textContent = message;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbm-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vbm-site-header')) return;

    class VbmSiteHeader extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.button = this.querySelector('[data-vbm-menu-button]');
        this.drawer = this.querySelector('[data-vbm-menu-drawer]');
        this.label = this.querySelector('[data-vbm-menu-label]');
        this.section = this.closest('.shopify-section');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        if (this.dataset.sticky === 'true') {
          this.section?.classList.add('vbm-site-header-section--sticky');
        }

        this.updateHeight = () => {
          const bounds = this.getBoundingClientRect();
          const height = bounds.height;
          const viewportBottom = Math.max(0, Math.min(window.innerHeight, bounds.bottom));
          this.style.setProperty('--vbm-site-header-height', `${height}px`);
          this.style.setProperty('--vbm-site-header-bottom', `${viewportBottom}px`);
          document.documentElement.style.setProperty('--header-height', `${height}px`);
        };

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateHeight);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.updateHeight, { signal });
        }
        this.updateHeight();

        if (!this.button || !this.drawer) return;

        this.button.addEventListener('click', () => this.toggleMenu(), { signal });
        this.drawer.addEventListener('click', (event) => {
          if (event.target.closest('a')) this.closeMenu(false);
        }, { signal });
        document.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.onBreakpointChange = (event) => {
          if (event.matches) this.closeMenu(false);
        };
        this.desktopQuery.addEventListener('change', this.onBreakpointChange);
      }

      toggleMenu() {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        open ? this.openMenu() : this.closeMenu();
      }

      openMenu() {
        this.section?.classList.add('vbm-site-header-section--menu-open');
        document.documentElement.classList.add('vbm-site-menu-open');
        this.updateHeight();
        this.drawer.hidden = false;
        this.button.setAttribute('aria-expanded', 'true');
        if (this.label) this.label.textContent = 'Sluiten';
        requestAnimationFrame(() => {
          this.updateHeight();
          this.drawer.querySelector('a')?.focus();
        });
      }

      closeMenu(returnFocus = true) {
        if (!this.button || !this.drawer) return;
        this.drawer.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        if (this.label) this.label.textContent = 'Menu';
        document.documentElement.classList.remove('vbm-site-menu-open');
        this.section?.classList.remove('vbm-site-header-section--menu-open');
        this.updateHeight();
        if (returnFocus) this.button.focus();
      }

      onKeydown(event) {
        if (this.drawer?.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeMenu();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [this.button, ...this.drawer.querySelectorAll('a[href], button:not([disabled])')]
          .filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        this.desktopQuery?.removeEventListener('change', this.onBreakpointChange);
        document.documentElement.classList.remove('vbm-site-menu-open');
        this.section?.classList.remove('vbm-site-header-section--menu-open');
      }
    }

    customElements.define('vbm-site-header', VbmSiteHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbm-work-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vbm-work-gallery')) {
    customElements.define('vbm-work-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.setupFrame) cancelAnimationFrame(this.setupFrame);
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.viewport || this.slides.length === 0) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.dialog = this.querySelector('dialog');
        this.dialogImage = this.querySelector('[data-dialog-image]');
        this.enlargeLinks = Array.from(this.querySelectorAll('[data-enlarge]'));
        this.index = 0;

        if (this.slides.length > 1 && this.previous && this.next && this.status) {
          const controls = this.querySelector('[data-controls]');
          if (controls) controls.hidden = false;
          this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
          this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
          this.viewport.addEventListener('scroll', () => {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.update());
          }, { ...options, passive: true });
          this.viewport.addEventListener('keydown', (event) => {
            if (event.target !== this.viewport) return;
            const destinations = {
              ArrowLeft: this.index - 1,
              ArrowRight: this.index + 1,
              Home: 0,
              End: this.slides.length - 1
            };
            if (!(event.key in destinations)) return;
            event.preventDefault();
            this.goTo(destinations[event.key]);
          }, options);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
              this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: 'auto' });
            });
            this.resizeObserver.observe(this.viewport);
          }
          this.update();
        }

        if (this.dialog && this.dialogImage && typeof this.dialog.showModal === 'function') {
          this.dialogPrevious = this.querySelector('[data-dialog-previous]');
          this.dialogNext = this.querySelector('[data-dialog-next]');
          this.dialogStatus = this.querySelector('[data-dialog-status]');

          this.enlargeLinks.forEach((link, linkIndex) => {
            link.addEventListener('click', (event) => {
              if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
              event.preventDefault();
              this.opener = link;
              this.showDialogPhoto(linkIndex);
              this.dialog.showModal();
              this.dialog.querySelector('[data-close]')?.focus();
            }, options);
          });

          this.dialogPrevious?.addEventListener('click', () => this.showDialogPhoto(this.dialogIndex - 1), options);
          this.dialogNext?.addEventListener('click', () => this.showDialogPhoto(this.dialogIndex + 1), options);
          this.dialog.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
            const destinations = {
              ArrowLeft: this.dialogIndex - 1,
              ArrowRight: this.dialogIndex + 1,
              Home: 0,
              End: this.enlargeLinks.length - 1
            };
            if (!(event.key in destinations)) return;
            event.preventDefault();
            this.showDialogPhoto(destinations[event.key]);
          }, options);

          this.dialog.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close(), options);
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => {
            if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          }, options);
        }
      }

      goTo(index) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left: destination * this.viewport.clientWidth,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      showDialogPhoto(index) {
        if (!this.enlargeLinks?.length) return;
        this.dialogIndex = Math.max(0, Math.min(index, this.enlargeLinks.length - 1));
        const link = this.enlargeLinks[this.dialogIndex];
        const original = link.querySelector('img');
        this.dialogImage.src = link.href;
        this.dialogImage.alt = original?.alt || '';
        this.dialogImage.width = Number(original?.getAttribute('width')) || 1600;
        this.dialogImage.height = Number(original?.getAttribute('height')) || 1200;
        this.dialogImage.hidden = false;

        const caption = this.dialog.querySelector('[data-caption]');
        if (caption) caption.textContent = link.dataset.caption || '';
        if (this.dialogPrevious) this.dialogPrevious.disabled = this.dialogIndex === 0;
        if (this.dialogNext) this.dialogNext.disabled = this.dialogIndex === this.enlargeLinks.length - 1;
        if (this.dialogStatus) {
          const photoLabel = this.dataset.photoLabel || 'Foto';
          const ofLabel = this.dataset.ofLabel || 'van';
          this.dialogStatus.textContent = `${photoLabel} ${this.dialogIndex + 1} ${ofLabel} ${this.enlargeLinks.length}`;
        }
      }

      update() {
        this.index = Math.max(0, Math.min(
          this.slides.length - 1,
          Math.round(this.viewport.scrollLeft / (this.viewport.clientWidth || 1))
        ));
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        if (this.status) {
          const photoLabel = this.dataset.photoLabel || 'Foto';
          const ofLabel = this.dataset.ofLabel || 'van';
          const phase = this.slides[this.index].dataset.phase || '';
          const message = `${photoLabel} ${this.index + 1} ${ofLabel} ${this.slides.length} · ${phase}`;
          if (this.status.textContent !== message) this.status.textContent = message;
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
